import { Outlet, createFileRoute } from "@tanstack/react-router";

import { requireSales } from "@/utils/routeGuards";

export const Route = createFileRoute("/app/sales")({
  beforeLoad: async ({ location }) => {
    await requireSales(location);
  },
  component: Outlet,
});
